














































import { ScheduleSlotRangeItem, ScheduleSlotRangesModel } from '@bookings/interfaces/schedule';
import { SlotPriceCategory } from '@bookings/interfaces/slot-price-category';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcScheduleSlotRangeSelector from './schedule-slot-range-selector.vue';
import BpcScheduleSlotRangeSelectorForAccessControl from './schedule-slot-range-selector-for-access-control.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import moment from 'moment';
import { cloneDeep } from 'lodash';

@Component({
  name: 'bpc-schedule-slot-range-grouped-form',
  components: {
    BpcScheduleSlotRangeSelector,
    BpcScheduleSlotRangeSelectorForAccessControl,
    'bpc-datepicker': Datepicker,
  },
})
export default class ScheduleSlotRangeGroupedForm extends Vue {
  @Prop(Object) readonly value: ScheduleSlotRangesModel;
  @Prop(Array) readonly categories: SlotPriceCategory[];
  @Prop(Boolean) readonly hideDate: boolean;
  @Prop({ type: Boolean, default: false }) readonly forAccessControl: boolean;

  get model(): ScheduleSlotRangesModel {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  modelReady = false;

  async mounted() {
    if (!this.value) {
      this.model = this.getEmptyScheduleSlotRangesModel();
    }
    this.modelReady = true;
    if (!this.categories && !this.forAccessControl) {
      await this.getSlotPriceCategories();
    } else {
      this.slotPriceCategories = this.categories;
      this.slotPriceCategoriesLoaded = true;
    }
  }

  slotPriceCategoriesLoaded = false;
  slotPriceCategories: SlotPriceCategory[] = [];

  get canLoadScheduleSelector(): boolean {
    return this.slotPriceCategoriesLoaded;
  }

  async getSlotPriceCategories() {
    this.slotPriceCategoriesLoaded = false;

    const config = {
      params: {
        per_page: 200,
      },
    };

    try {
      const res = await this.$bpcApi
        .get(this.$bpcApiRouteHelper.getEntityPath('slot-price-categories'), config)
        .toPromise();

      this.slotPriceCategories = res.data;

      this.slotPriceCategoriesLoaded = true;
    } catch (error) {
      this.$bpcMessage.showErrorMessage({ text: 'global.generic.server_error' });
    }
  }

  timeFormat = 'HH:mm';
  publicTimeFormat = 'HH:mm';

  get slotDuration() {
    return this.$store.getters['centerSettings/centerSettings']?.default_slot_duration || 30;
  }

  get startTime() {
    if (this.forAccessControl) {
      return '00:00:00';
    } else {
      return this.$store.getters['centerSettings/centerSettings']?.default_start_hour;
    }
  }

  get endTime() {
    if (this.forAccessControl) {
      return '23:59:59';
    } else {
      return this.$store.getters['centerSettings/centerSettings']?.default_end_hour;
    }
  }

  getEmptyScheduleSlotRangesModel(): ScheduleSlotRangesModel {
    const next = moment(this.startTime, this.timeFormat);

    // If the endTime is after next it is in the same day if not, it is in the next day (00:30 for example)
    const end = moment(this.endTime, this.timeFormat).isAfter(next)
      ? moment(this.endTime, this.timeFormat)
      : moment(this.endTime, this.timeFormat).add(1, 'days');

    const scheduleSlotRanges: ScheduleSlotRangeItem[] = [];

    while (next.isSameOrBefore(end)) {
      const slotEndTime = next.clone().add(this.slotDuration, 'minutes');
      const newScheduleSlotRange = {
        start_time: next.format(this.publicTimeFormat),
        end_time: slotEndTime.format(this.publicTimeFormat),
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null,
        sun: null,
      };

      // Set end time maximum the end time of the center
      if (slotEndTime.isAfter(end)) {
        newScheduleSlotRange.end_time = end.format(this.publicTimeFormat);
      }

      scheduleSlotRanges.push(newScheduleSlotRange);
      next.add(this.slotDuration, 'minutes');
    }

    return {
      start_date: null,
      business_day: cloneDeep(scheduleSlotRanges),
      holiday: cloneDeep(scheduleSlotRanges),
      bank_holiday: cloneDeep(scheduleSlotRanges),
    };
  }
}
